import { utagLinkCart } from 'features/tealium/';

import CartBaseItemView from '../../baseViews/ItemView';
import PromoCodeStatusMessageTemplate from '../templates/PromoCodeStatusMessageTemplate';

const trackCartEvents = utagLinkCart();

const PromoCodeStatusMessage = CartBaseItemView.extend({
	className: 'promoCodeText',
	JSXTemplate: PromoCodeStatusMessageTemplate,
	initialize () {

		this.listenTo(this.model, 'change', this.render, this);

	},
	onRender () {

		const promoCodeError = this.model.get('promoCodeError');

		if (promoCodeError) {

			this.$el.addClass('error');

			let eventActionValue = '';
			let sendError = false;

			if ([ 'none', 'consumer', 'professional' ].includes(window.utag_data.user_type.toLowerCase())) {

				sendError = true;
				eventActionValue = 'Error-Coupon';

			}

			if (window.utag_data.user_type.toLowerCase() === 'employee') {

				sendError = true;
				eventActionValue = 'Employee-Error-Coupon';

			}

			if (sendError) {

				trackCartEvents({
					eventAction: eventActionValue,
					eventLabel: `${promoCodeError} - ${this.model.get('SelectedPromoCode')}`
				});

			}

		} else {

			this.$el.removeClass('error');

		}

	},
	onDomRefresh () {

		if (this.model.get('SelectedPromoCode')) {

			this.$el.parent().removeClass('hidden');

		} else {

			this.$el.parent().addClass('hidden');

		}

	}
});

export default PromoCodeStatusMessage;
